<template>
  <tbody>
    <tr v-for="item in formatedItems" :key="item.id" class="text-xs-center hovereable">
      <td class="text-xs-left">
        {{ item.first_name }} {{ item.last_name }}
        <small>{{ item.email }}</small>
      </td>
      <td>
        {{ item.role.display_name }}
      </td>
      <td>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn
              flat
              icon
              class="mx-1"
              v-for="channel in channels"
              :key="`channel-${item.id}-${channel.value}`"
              :disabled="ajaxOn"
              @click="addChannel(item.id, channel.value)">
              <v-icon small :class="{ 'k-orange-linear-text': hasFilters(item, channel) }">
                {{ channel.icon }}
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </td>
    </tr>
  </tbody>
</template>

<script>
import _ from 'lodash';
import dataTableMixin from '@/mixins/dataTableList';

export default {
  mixins: [
    dataTableMixin,
  ],
  props: [
    'items',
  ],
  data() {
    return {
      route: 'users',
      ajaxOn: false,
      channels: [
        {
          icon: 'fa-comment',
          value: 2,
          description: 'SMS',
        },
        {
          icon: 'fab fa-whatsapp',
          value: 7,
          description: 'Whatsapp',
        },
        {
          icon: 'fa-envelope',
          value: 1,
          description: 'Email',
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    formatedItems() {
      return this.items.map((item) => {
        if (item.chat_center_filters) {
          const chatCenterFilters = JSON.parse(item.chat_center_filters);
          // eslint-disable-next-line
          item = {
            chatCenterFilters,
            ...item,
          };
        }
        return item;
      });
    },
  },
  methods: {
    hasFilters(item, channel) {
      const filters = item.chatCenterFilters;
      return item.chat_center_filters ? filters.channels.includes(channel.value) : false;
    },
    addChannel(id, channel) {
      const index = this.items.findIndex(item => item.id === id);
      if (index !== -1) {
        if (!this.formatedItems[index].chatCenterFilters) {
          this.items[index].chat_center_filters = JSON.stringify({
            channels: [],
          });
        }
        const channels = this.formatedItems[index].chatCenterFilters.channels;
        const idx = channels.findIndex(item => item === channel);
        if (idx === -1) {
          channels.push(channel);
        } else {
          channels.splice(idx, 1);
        }
        const obj = {
          channels,
        };
        this.items[index].chat_center_filters = JSON.stringify(obj);
        this.updateChatCenterFilters(this.items[index], this.items[index].chat_center_filters);
      }
    },
    // eslint-disable-next-line
    updateChatCenterFilters: _.debounce(function (item, channels) {
      this.ajaxOn = true;
      this.axios.patch(`chats_centers/${item.id}/config`, {
        channels,
      }).then(() => {
        if (item.id === this.user.id) {
          this.user.chat_center_filters = JSON.parse(channels);
        }
        this.ajaxOn = false;
      });
    }, 800),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ChatCenterUserList.vue